export default __webpack_public_path__ + "static/media/logo-deally.afad8a30.svg";